export const networkColorList = {
  mainnet: "blue",
  cronos: "blue",
  testnet3: "yellow",
  "cronos-testnet": "yellow",
  "-": "grey",
} as any;
